import React, { useState } from "react";
import FromPageIndicator from "../Common/FromPageIndicator";
import { Container, Card, ListGroup } from "react-bootstrap";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import SampleAbstractPDF from "../../Assets/AbstractTemplatetnpyAmpicon2025.docx";

const AbstractGuidelines = () => {
  const [downloading, setDownloading] = useState(false);

  const handleDownload = () => {
    setDownloading(true);
    const link = document.createElement("a");
    link.href = SampleAbstractPDF;
    link.download = "Abstract Template tnpy ampicon2025";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setDownloading(false);
  };

  return (
    <>
      <FromPageIndicator />
      <Container
        fluid
        className="py-5 px-4"
        style={{ backgroundColor: "#FFF4FA" }}
      >
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          <div
            className="mx-auto"
            style={{ width: "100%", maxWidth: "1000px" }}
          >
            <Card className="shadow-lg border-0 rounded-4 w-100">
              <Card.Body className="">
                <h2
                  className="text-center fw-bold mb-4"
                  style={{ color: "#2482a1" }}
                >
                  TNPY AMPICON 2025
                </h2>

                {/* <div className="bg-light p-4 rounded mb-4">
                  <h4 style={{ fontFamily: "Arial", fontWeight: "bold", fontSize: "12pt" }}>
                    Evaluation of a Novel Deep Learning Model for Automated Tumor Segmentation in Prostate Cancer
                  </h4>
                  
                  <p style={{ fontFamily: "Arial", fontStyle: "italic", fontSize: "11pt" }}>
                    K M Rafic, Department of Radiation Oncology, Apollo Hospitals Vanagaram, Chennai.<br/>
                    Ganapathy Krishnan, Department of Medical Physics, Apollo Proton Centre, Chennai.<br/>
                    Anto Vaz, Department of Radiation Oncology, Kovai Medical Centre and Hospital, Coimbatore. Email of corresponding author: kmrafic@gmail.com
                  </p>
                  
                  <h5 style={{ fontFamily: "Arial", fontWeight: "bold", fontSize: "11pt" }}>Background and Aim</h5>
                  <p style={{ fontFamily: "Arial", fontSize: "11pt" }}>
                    Prostate cancer treatment planning critically depends on accurate tumor delineation. Manual segmentation is time-consuming and subject to inter-observer variability. This study evaluates a novel deep learning-based approach for automated tumor segmentation.
                  </p>
                  
                  <h5 style={{ fontFamily: "Arial", fontWeight: "bold", fontSize: "11pt" }}>Materials & Methods</h5>
                  <p style={{ fontFamily: "Arial", fontSize: "11pt" }}>
                    A dataset of 150 anonymized Prostate CT scans was used to train a 3D U-Net model. Manual contours from three expert oncologists served as the ground truth. The model performance was evaluated using the Volumetric Dice Similarity Coefficient (DSC) and Hausdorff Distance (HD).
                  </p>
                  
                  <h5 style={{ fontFamily: "Arial", fontWeight: "bold", fontSize: "11pt" }}>Results and Discussion</h5>
                  <p style={{ fontFamily: "Arial", fontSize: "11pt" }}>
                    The proposed model achieved a mean DSC of 0.89 ± 0.04 and a 95th percentile HD of 3.2 mm across test cases. The segmentation time was reduced by over 90% compared to manual contouring.
                  </p>
                  
                  <h5 style={{ fontFamily: "Arial", fontWeight: "bold", fontSize: "11pt" }}>Conclusion</h5>
                  <p style={{ fontFamily: "Arial", fontSize: "11pt" }}>
                    The deep learning model demonstrated high accuracy and efficiency in tumor segmentation for Prostate cancer. This approach holds potential for routine clinical implementation to assist radiation oncologists in treatment planning.
                  </p>
                  
                  <p style={{ fontFamily: "Arial", fontSize: "11pt" }}>
                    <strong>Keywords:</strong> Tumor Segmentation, Deep Learning, Prostate Cancer
                  </p>
                </div> */}

                <h4 className="mt-4" style={{ color: "#2482a1" }}>
                  Abstract Preparation Guidelines
                </h4>
                <ListGroup variant="flush" className="mb-4">
                  <ListGroup.Item>
                    <strong>1. Title:</strong>
                    <ul>
                      <li>
                        Must be clear, descriptive, and without abbreviations.
                      </li>
                      <li>Maximum 145 characters (excluding spaces).</li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>2. Authors:</strong>
                    <ul>
                      <li>
                        Provide full names and institutional affiliations of all
                        authors.
                      </li>
                      <li>
                        First/Presenting author must provide email, mobile
                        number, and institutional affiliation.
                      </li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>3. Abstract File Preparation:</strong>
                    <ul>
                      <li>
                        Submit as a single Microsoft Word document (.doc/.docx).
                      </li>
                      <li>
                        Include the title page and the abstract in the same
                        file.
                      </li>
                      <li>Maximum 350 words with the following structure:</li>
                      <ul>
                        <li>
                          <strong>Background and Aim</strong>
                        </li>
                        <li>
                          <strong>Materials and Methods</strong>
                        </li>
                        <li>
                          <strong>Results and Discussion</strong>
                        </li>
                        <li>
                          <strong>Conclusion</strong>
                        </li>
                      </ul>
                      <li>
                        Provide three relevant keywords reflecting the research
                        content.
                      </li>
                      <li>
                        Example Document -{" "}
                        <button
                          onClick={handleDownload}
                          disabled={downloading}
                          style={{
                            background: "none",
                            border: "none",
                            padding: 0,
                            margin: 0,
                            color: downloading ? "#888" : "#2482a1",
                            cursor: downloading ? "not-allowed" : "pointer",
                            fontWeight: "bold",
                            textDecoration: "underline",
                          }}
                        >
                          {downloading ? "Downloading..." : "Download"}
                        </button>
                      </li>
                    </ul>
                  </ListGroup.Item>
                  <ListGroup.Item>
                    <strong>4. Category:</strong>
                    <p>Select one category during submission:</p>
                    <ul>
                      <li>Radiation Oncology: Physics and Dosimetry</li>
                      <li>Diagnostic Imaging: Physics and Dosimetry</li>
                      <li>Nuclear Medicine: Physics and Dosimetry</li>
                      <li>Image Processing, Analysis and Quantification</li>
                      <li>Particle Therapy and Dosimetry</li>
                      <li>Monte-Carlo Modelling and Simulation</li>
                      <li>
                        AI/ML in Medical Physics & Clinical Implementation
                      </li>
                      <li>IGRT and Adaptive Radiotherapy</li>
                      <li>Radiation Biology, Protection, and Safety</li>
                      <li>Diagnostic & Therapeutic Instrumentation</li>
                      <li>3D Printing, QA Device, Phantom Design</li>
                      <li>Medical Physics Education and Certification</li>
                    </ul>
                  </ListGroup.Item>
                </ListGroup>

                <h4 style={{ color: "#2482a1" }}>Presentation Categories</h4>
                <ul>
                  <li>
                    <strong>Oral Presentation –</strong> Updated details coming
                    soon
                  </li>
                  <li>
                    <strong>E-Poster Presentation –</strong> Updated details
                    coming soon
                  </li>
                </ul>

                <h5 className="mt-4" style={{ color: "#2482a1" }}>
                  Submission Process
                </h5>
                <ul>
                  <li>Online submission is the only accepted method.</li>
                  <li>
                    A maximum of two abstracts can be submitted per primary
                    author.
                  </li>
                  <li>
                    Ensure adherence to the guidelines to avoid rejection.
                  </li>
                </ul>

                <p className="mt-4">
                  For queries, please email:{" "}
                  <a href="mailto:tnpyampicon2025@gmail.com">
                    tnpyampicon2025@gmail.com
                  </a>
                </p>
                <p>
                  <strong>
                    We look forward to your valuable contributions and an
                    engaging scientific exchange at TNPY AMPICON 2025!
                  </strong>
                </p>
              </Card.Body>
            </Card>
          </div>
        </motion.div>
      </Container>
    </>
  );
};

export default AbstractGuidelines;
